import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import JobTypeComponent from "./JobTypeComponent";
import ClientOpenJobsComponent from "./open-jobs/ClientOpenJobsComponent";
import ClientArchivedJobsComponent from "./archived-jobs/ClientArchivedJobsComponent";
import ClientPrivateJobsComponent from "./privately-shared/ClientPrivateJobsComponent";

const PostJobsComponent = ({ user }) => {
  const [activeJobCount] = useState(0);
  const [showJobTypeComponent, setShowJobTypeComponent] = useState(false);

  const navigate = useNavigate();
  const { tab } = useParams();

  const tabNames = {
    open: "Open Jobs",
    archived: "Archived",
    "privately-shared": "Privately Shared",
  };

  const tabComponents = {
    open: <ClientOpenJobsComponent />,
    archived: <ClientArchivedJobsComponent />,
    "privately-shared": <ClientPrivateJobsComponent />,
  };

  const [activeTab, setActiveTab] = useState(tab || "open");

  useEffect(() => {
    setActiveTab(tab || "open");
  }, [tab]);

  const handleTabClick = (key) => {
    navigate(`/account/fs-dashboard/my-jobs/${key}`);
    setActiveTab(key);
  };

  const handleShowJobTypeComponent = () => {
    window.history.pushState(null, null, window.location.pathname);
    setShowJobTypeComponent(true);
  };

  if (showJobTypeComponent) {
    return <JobTypeComponent user={user} />;
  }

  return (
    <div className="post-jobs-container">
      <div className="post-jobs-tabs">
        <div className="tabs-group">
          <div className="tabs">
            {Object.entries(tabComponents).map(([key, component]) => (
              <div
                key={key}
                className={`tab ${activeTab === key ? "active" : ""}`}
                onClick={() => handleTabClick(key)}
              >
                {tabNames[key]}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="post-job-tab-content">{tabComponents[activeTab]}</div>
    </div>
  );
};

export default PostJobsComponent;
